/**
 * Conifer Point branding for the MD reports (PDF and PowerPoint): the footer
 * line and the notice text shown on the title page / title slide. The logo and
 * footer bar images are in mdReportLogo.js; the slide geometry follows the
 * company slide master (2026_ConiferPoint_MasterSlides).
 */

export const REPORT_COMPANY = 'Conifer Point Pharmaceuticals';

/**
 * Notice text printed under the details on the report's title page and title
 * slide, one paragraph per entry (confidentiality, disclaimer, usage terms,
 * ...). Add entries here and both formats pick them up.
 * @type {string[]}
 */
export const REPORT_NOTICES = [];

/**
 * The footer line on every page / slide.
 * @param {Date} [date]
 * @returns {string}
 */
export function reportCopyright(date = new Date()) {
    return `© ${date.getFullYear()} ${REPORT_COMPANY}`;
}
